import { transformDigitToFinancial } from "../../../../utils/formatters/transformDigitToFinancial";

export const transformPrice = (price: number | string) =>
  transformDigitToFinancial(price, { withCurrencySign: true, withFloat: true });
